import { IconCirclePlus, IconSearch } from "@tabler/icons-react";

const TabTarifasClientes = ({ tarifasClientes = [], onEditar, busqueda, setBusqueda, abrirModal }) => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <div className="input-icon" style={{ minWidth: "300px" }}>
          <input type="text" className="form-control" placeholder="Buscar por tipo de tarifa o cliente..." value={busqueda} onChange={(e) => setBusqueda(e.target.value)} />
          <span className="input-icon-addon">
            <IconSearch size={18} />
          </span>
        </div>

        <button className="btn btn-primary btn-pill" onClick={abrirModal} title="Agregar nueva tarifa" aria-label="Agregar nueva tarifa">
          <IconCirclePlus size={18} className="me-1" />
          Agregar TarifaClientes
        </button>
      </div>

      <div className="table-responsive">
        <table className="table table-hover table-striped table-vcenter">
          <thead>
            <tr>
              <th>Tarifa</th>
              <th>Clientes</th>
              <th>Estado</th>
              <th>Creado por</th>
            </tr>
          </thead>
          <tbody>
            {tarifasClientes.length > 0 ? (
              tarifasClientes.map((item) => (
                <tr key={item.id} onClick={() => onEditar?.(item)} style={{ cursor: "pointer" }}>
                  <td>{item.tarifa_nombre}</td>
                  <td>{item.cliente_nombre}</td>
                  <td>
                    <span className="d-inline-flex align-items-center">
                      <span className={`badge me-1 ${item.estado === 1 ? "bg-success" : "bg-secondary"}`}></span>
                      {item.estado === 1 ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                  <td>{item.username}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted">
                  No se encontraron tarifas.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TabTarifasClientes;
